import React, { useState } from 'react';
import '../../styles/about/impact.css';
import { isMobile } from 'mobile-device-detect';
import gothenborgLogo from '../../assets/svg/sponsors/gothenburg.svg'
import kiLogo from '../../assets/svg/sponsors/ki-logo.svg';
import lundLogo from '../../assets/svg/sponsors/lund-logo.svg';
import kuLogo from '../../assets/svg/sponsors/ku-logo.svg';
import rs from '../../assets/svg/sponsors/regionS-logo.svg';
import vastraGot from '../../assets/svg/sponsors/vastraGot-logo.svg';
import beckamC from '../../assets/svg/sponsors/beckmancoulte-logo.svg';
import brucker from '../../assets/svg/sponsors/Bruker-logo.svg';
import astraZ from '../../assets/svg/sponsors/AZN-logo.svg';
import bioms from '../../assets/svg/sponsors/bioms-logo.svg';
import scilifelab from '../../assets/svg/sponsors/scilifelab-logo.svg';
import gms from '../../assets/svg/sponsors/gms-svg.svg';
import cancerCore from '../../assets/svg/sponsors/cancercore-logo.svg';
import universityGotenburg from '../../assets/img/gothenburg.jpg'
import { ReactComponent as Target } from '../../assets/svg/target.svg';
import { ReactComponent as Sweden } from '../../assets/svg/sweden-svg.svg';
import { ReactComponent as Knot } from '../../assets/svg/knot.svg';

const sponsorsData = [
	{
		category: 'Academic Partners',
		logos: [
			{
				id: 'ki',
				name: 'Karolinska Institutet',
				description: 'Leading clinical proteomics research and development.',
				link: 'https://ki.se/',
				miniLogo: kiLogo,
				largeLogo:
					'https://medarbetare.ki.se/sites/medarbetare/files/qbank/ki_digital_logo_rgb-custom20221013163945.jpg',
			},
			{
				id: 'lund',
				name: 'Lund University',
				description: 'Expertise in plasma proteomics and clinical proteomics innovation.',
				link: 'https://www.lunduniversity.lu.se/',
				miniLogo: lundLogo,
				largeLogo:
					'https://www.lunduniversity.lu.se/sites/www.lunduniversity.lu.se/files/Lund_university_L_CMYK.svg',
			},
			{
				id: 'got',
				name: 'University of Gothenburg',
				description: 'Driving platform harmonization and automation for proteomics.',
				link: 'https://www.gu.se/en',
				miniLogo: gothenborgLogo,
				largeLogo: universityGotenburg,
			},
		],
	},
	{
		category: 'Healthcare Partners',
		logos: [
			{
				id: 'ku',
				name: 'Karolinska University Hospital',
				description:
					'Established the first clinical proteomics unit and is part of the comprehensive cancer center network.',
				link: 'https://www.karolinskahospital.com/',
				miniLogo: kuLogo,
				largeLogo:
					'https://www.karolinska.se/4abb82/contentassets/5c71fd858242471c8ed31e6c44aef65c/karolinska_english_logo_srgb.jpg?preset=320',
			},
			{
				id: 'vastra',
				name: 'Region Västra Götaland',
				description: 'Supporting clinical trials like FOCU.SE.',
				link: 'https://www.vgregion.se/',
				miniLogo: vastraGot,
				largeLogo:
					'https://www.vgregion.se/contentassets/64fc291335c141bea2ed24107db1e821/vgr23-kisvart20logotyp_23528.png',
			},
			{
				id: 'rs',
				name: 'Region Skåne',
				description: 'Running lung and breast cancer studies through SCAN-B and LUCAS initiatives.',
				link: 'https://www.skane.se/',
				miniLogo: rs,
				largeLogo: 'https://www.skane.se/Static/img/logos/RSKlogo-rgb.svg',
			},
		],
	},
	{
		category: 'Industry Partners',
		logos: [
			{
				id: 'az',
				name: 'AstraZeneca',
				description: 'Leading in precision medicine innovations and tumor-informed monitoring through proteomics.',
				link: 'https://www.astrazeneca.com/',
				miniLogo: astraZ,
				largeLogo: 'https://www.astrazeneca.com/etc/designs/az/img/logo-az.png',
			},
			{
				id: 'bruker',
				name: 'Bruker Daltonics',
				description: 'Providing proteomics solutions and advancing mass spectrometry technologies.',
				link: 'https://www.bruker.com/en.html',
				miniLogo: brucker,
				largeLogo: 'https://www.bruker.com/content/dam/global/logos/logo.svg',
			},
			{
				id: 'beckman',
				name: 'Beckman Coulter',
				description: 'Specializing in laboratory automation for clinical proteomics.',
				link: 'https://www.beckmancoulter.com/',
				miniLogo: beckamC,
				largeLogo:
					'https://media.beckmancoulter.com/-/media/diagnostics/corporate/logos/beckman-logo-svg.svg',
			},
		],
	},
	{
		category: 'Infrastructure and Ecosystem Partners',
		logos: [
			{
				id: 'bioms',
				name: 'BioMS (Swedish National Infrastructure for Biological Mass Spectrometry)',
				description: 'Providing core infrastructure for proteomics research.',
				link: 'https://bioms.se/',
				miniLogo: bioms,
				largeLogo:
					'https://bioms.se/wp-content/uploads/2021/11/cropped-logo-remake-bioms-4-2048x1117.png',
			},
			{
				id: 'scilifelab',
				name: 'SciLifeLab',
				description: 'Supporting national precision medicine platforms and data-driven life sciences.',
				link: 'https://www.scilifelab.se/',
				miniLogo: scilifelab,
				largeLogo:
					'https://www.scilifelab.se/wp-content/uploads/2022/06/SciLifeLab_Logotype_Green_POS.svg',
			},
			{
				id: 'gms',
				name: 'Genome Medicine Sweden (GMS)',
				description: 'Connecting clinical genomics to proteomics.',
				link: 'https://genomicmedicine.se/en/',
				miniLogo: gms,
				largeLogo: 'https://genomicmedicine.se/wp-content/uploads/2019/05/GMS-logo-namn-RGB-300.png',
			},
		],
	},
	{
		category: 'International Collaborators',
		logos: [
			{
				id: 'cce',
				name: 'Cancer Core Europe',
				description: 'Engaging in large cancer precision medicine clinical trials.',
				link: 'https://www.cancercoreeurope.eu/',
				miniLogo: cancerCore,
				largeLogo:
					'https://www.cancercoreeurope.eu/website/wp-content/uploads/2023/11/cancer_core_europe.png',
			},
		],
	},
];

const SponsorSection = ({ category, logos }) => (
	<div className="sponsors-circle">
		<h5>{category}</h5>
		<span className="sponsors-circle-layout">
			{logos.map(({ id, name, description, link, miniLogo, largeLogo }) =>
				isMobile ? (
					<span className="logo-wrapper-mobile" key={id}>
						<a href={link} target="_blank" rel="noreferrer">
							<img src={largeLogo} alt={`${name} logo`} />
						</a>
						<h4>{name}</h4>
						<p>{description}</p>
					</span>
				) : (
					<a href={link} target="_blank" rel="noreferrer" key={id}>
						<div className="logo-wrapper">
							<img className="impact-logo" src={miniLogo} alt={`${name} mini-logo`} />
							<div className="popup">
								<img src={largeLogo} alt={`${name} logo`} />
								<h4>{name}</h4>
								<p>{description}</p>
							</div>
						</div>
					</a>
				)
			)}
		</span>
	</div>
);

const ImpactSection = () => {
	return (
		<section className="impact-section">
			<span className="impact-section-info">
				<h1>Transforming Cancer Care and Beyond</h1>
				<p>
					ProMS is not just about better cancer care; it's about creating a global hub for proteomics research,
					attracting international collaborations, and enabling breakthroughs in personalized medicine. Our efforts
					will:
				</p>
				<section className="impact-section-info-goals">
					<div className="impact-goal">
						<Target className="icon"/>
						<p>Improve diagnostic accuracy for cancer patients</p>
					</div>
					<div className="impact-goal">
						<Sweden className="icon"/>
						<p>Make Sweden a leader in precision medicine research</p>
					</div>
					<div className="impact-goal">
						<Knot className="icon" />
						<p>Strengthen global collaborations and innovation in proteomics</p>
					</div>
				</section>
			</span>
			<div className="sponsors" id="sponsors">
				{sponsorsData.map((sponsorCategory) => (
					<SponsorSection
						key={sponsorCategory.category}
						category={sponsorCategory.category}
						logos={sponsorCategory.logos}
					/>
				))}
			</div>
		</section>
	);
};

export default ImpactSection;
